import axios from "axios";
import { api } from "./helper";

const client = axios.create({
  baseURL: api,
  withCredentials: false,
});


function GetTrackFiles(sourcetype, sourceId) {
  const params = {
    sourcetype: sourcetype,
    sourceId: sourceId
  };
  return client.get("/TrackFiles", { params });
}

function GetTrackDocs(sourcetype, sourceId) {
  const params = {
    sourcetype: sourcetype,
    sourceId: sourceId
  };
  return client.get("/TrackingDocs", { params });
}

export 
{
   GetTrackFiles,
   GetTrackDocs

};